import useTranslation from 'next-translate/useTranslation';

import { ProductItem } from '@/lib/types/api';
import GetQuoteForm from '@/components/forms/GetQuoteForm';
import VisitTheMachine from '@/components/forms/VisitTheMachine';
import MakeCounterOffer from '@/components/forms/MakeCounterOffer';
import DownloadPDF from '@/components/forms/DownloadPDF';
import {
  ProductAccountManager,
  ProductPaymentInfo,
} from '@/components/product';
import { ProductSoldBanner } from '@/components/product/ProductSoldBanner';

export function ProductPageSidebar({
  product,
  isAvailable,
}: {
  product: ProductItem;
  isAvailable: boolean;
}) {
  const { t } = useTranslation();
  return (
    <div className='no-print bg-white md:min-w-[30em] min-[1400px]:sticky min-[1400px]:top-20 min-[1400px]:float-right min-[1400px]:mr-40 min-[1400px]:w-1/3 min-[1400px]:border-2 min-[1400px]:shadow-xl'>
      <div className='border-b-[1px] border-gray-300 px-2 text-brand-500 lg:px-0'>
        <section className='mx-auto my-6 max-w-md space-y-4 px-4 text-center'>
          <h1 className='space-y-2'>
            <span className='h3 text-md'>
              {product.brand.name} - {product.model}
            </span>
            <span className='h3 block text-sm'>{product.sku}</span>
          </h1>
        </section>

        {isAvailable ? (
          <>
            <section className='mx-auto my-6 max-w-md space-y-4 px-4 text-center'>
              <ProductPaymentInfo product={product} priceClass='h2' />
              <GetQuoteForm product={product} />
              <VisitTheMachine product={product} />
            </section>
            <MakeCounterOffer product={product} />
            <DownloadPDF product={product} />
          </>
        ) : (
          <ProductSoldBanner message={t('products:Sold')} />
        )}
      </div>
      <ProductAccountManager isCentered />
    </div>
  );
}
